"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _size2 = _interopRequireDefault(require("lodash/size"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _slate = require("slate");
var _slateReact = require("slate-react");
var _slateHistory = require("slate-history");
var _slatePlugins = require("@udecode/slate-plugins");
var _components = require("./components");
var _getHtmlDocument = _interopRequireDefault(require("../../utils/getHtmlDocument"));
var _htmlDecode = _interopRequireDefault(require("../../utils/htmlDecode"));
var _isHtml = _interopRequireDefault(require("../../utils/isHtml"));
var _config = require("./lib/config");
var _linkify = require("./lib/linkify");
var _paragraph = require("./lib/paragraph");
var _div = require("./lib/div");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
// TODO: update slate when pr will merged
// HACK: fixing Slate react auto scroll problem
// About problem: https://github.com/ianstormtaylor/slate/pull/3746
var toDOMRange = _slateReact.ReactEditor.toDOMRange;
_slateReact.ReactEditor.toDOMRange = function (editor, selection) {
  var range = toDOMRange(editor, selection);
  if (range.startContainer.parentElement) {
    range.startContainer.parentElement.getBoundingClientRect = range.getBoundingClientRect.bind(range);
  }
  return range;
};
var createPlugins = function createPlugins(pluginOptions) {
  return [(0, _slatePlugins.BoldPlugin)(), (0, _slatePlugins.ItalicPlugin)(), (0, _slatePlugins.UnderlinePlugin)(), (0, _slatePlugins.StrikethroughPlugin)(), (0, _slatePlugins.ImagePlugin)(), (0, _slatePlugins.TablePlugin)(), (0, _slatePlugins.ExitBreakPlugin)(), (0, _slatePlugins.SoftBreakPlugin)(), (0, _slatePlugins.LinkPlugin)(), (0, _linkify.linkifyPlugin)(pluginOptions), (0, _paragraph.paragraphPlugin)(pluginOptions), (0, _div.plainTextInDivPlugin)(pluginOptions)];
};
var plugins = createPlugins(_config.options);
var serializablePlugins = createPlugins(_config.serializableOptions);
var withPlugins = [_slateReact.withReact, _slateHistory.withHistory, (0, _linkify.withLink)(_config.options), (0, _slatePlugins.withInlineVoid)({
  plugins: plugins
})];
var Editor = function Editor(props) {
  var className = props.className,
    placeholder = props.placeholder,
    outerValue = props.outerValue,
    toolbarMarks = props.toolbarMarks,
    toolbarButtons = props.toolbarButtons,
    onChange = props.onChange,
    onFocus = props.onFocus,
    onBlur = props.onBlur,
    editorId = props.editorId,
    disableToolbar = props.disableToolbar,
    plain = props.plain;
  var serializePlaintextFromNodes = function serializePlaintextFromNodes(nodes) {
    return nodes.map(function (n) {
      return _slate.Node.string(n);
    }).join('\n');
  };
  var deserialize = (0, _react.useMemo)(function () {
    return (0, _slatePlugins.deserializeHTMLToDocument)(plugins);
  }, [plugins]);
  var serialize = (0, _react.useMemo)(function () {
    return plain ? serializePlaintextFromNodes : (0, _slatePlugins.serializeHTMLFromNodes)(serializablePlugins);
  }, [serializablePlugins, plain]);
  var getValue = (0, _react.useCallback)(function (str) {
    if (str.trim() && (0, _isHtml["default"])((0, _htmlDecode["default"])(str))) {
      return deserialize((0, _getHtmlDocument["default"])((0, _htmlDecode["default"])(str)).body);
    }
    return deserialize((0, _getHtmlDocument["default"])("<p>".concat(str, "</p>")).body);
  }, [deserialize]);
  var initialValue = (0, _react.useMemo)(function () {
    return getValue(outerValue);
  }, [outerValue]);
  var _useState = (0, _react.useState)(initialValue),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  var editor = (0, _react.useMemo)(function () {
    return _slatePlugins.pipe.apply(void 0, [(0, _slate.createEditor)()].concat(withPlugins));
  }, []);
  editor.id = editorId;
  var editorRef = (0, _react.useRef)();
  var handleChange = (0, _react.useCallback)(function (newValue) {
    setValue(newValue);
    onChange(serialize(newValue));
  }, [onChange]);
  (0, _react.useEffect)(function () {
    if (outerValue !== serialize(value)) {
      _slate.Transforms.deselect(editor);
      editor.children = getValue(outerValue);
      setValue(getValue(outerValue));
    }
  }, [outerValue]);
  (0, _react.useEffect)(function () {
    if (plain) {
      var valueChildrens = (0, _get2["default"])(value, '[0].children');
      if ((0, _size2["default"])(valueChildrens) > 1) _slate.Transforms.mergeNodes(editor);
    }
  }, [plain, value]);
  return /*#__PURE__*/_react["default"].createElement(StyledEditor, (0, _extends2["default"])({
    id: editorId,
    className: className
  }, props), /*#__PURE__*/_react["default"].createElement(_slateReact.Slate, {
    ref: editorRef,
    value: value,
    editor: editor,
    onChange: handleChange
  }, !disableToolbar && /*#__PURE__*/_react["default"].createElement(_components.Toolbar, {
    marks: toolbarMarks,
    buttons: toolbarButtons
  }), /*#__PURE__*/_react["default"].createElement(_slatePlugins.EditablePlugins, {
    onFocus: onFocus,
    onBlur: onBlur,
    plugins: plugins,
    placeholder: placeholder,
    spellCheck: true
  })));
};
Editor.propTypes = {
  editorId: _propTypes["default"].string.isRequired,
  className: _propTypes["default"].string,
  outerValue: _propTypes["default"].string,
  placeholder: _propTypes["default"].string,
  onChange: _propTypes["default"].func,
  onFocus: _propTypes["default"].func,
  onBlur: _propTypes["default"].func,
  disableToolbar: _propTypes["default"].bool,
  toolbarMarks: _propTypes["default"].arrayOf(_propTypes["default"].string),
  toolbarButtons: _propTypes["default"].arrayOf(_propTypes["default"].element),
  plain: _propTypes["default"].bool
};
Editor.defaultProps = {
  className: '',
  outerValue: '',
  placeholder: '',
  toolbarMarks: [_components.TOOLBAR_ITEMS.BOLD, _components.TOOLBAR_ITEMS.ITALIC, _components.TOOLBAR_ITEMS.UNDERLINE, _components.TOOLBAR_ITEMS.STRIKETHROUGH],
  toolbarButtons: [],
  onChange: Function.prototype,
  onFocus: Function.prototype,
  onBlur: Function.prototype,
  disableToolbar: false,
  plain: false
};
var StyledEditor = _styledComponents["default"].div.withConfig({
  displayName: "Editor__StyledEditor",
  componentId: "sc-9y5yyq-0"
})(["position:relative;width:100%;min-width:300px;max-width:960px;background:white;font-family:'ONYOneFont','Helvetica',sans-serif;font-size:14px;line-height:1.36;padding:10px 10px;"]);
var _default = exports["default"] = Editor;